import axios, { AxiosRequestConfig /*, AxiosResponse */ } from 'axios';
import { message } from 'antd';

// 创建 axios 实例
const request = axios.create({
    baseURL: 'https://gateway.banli668.com', // API 地址
    // baseURL: 'http://192.168.1.239:9090', // API 地址（本地测试）
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 请求拦截器
request.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么
        // 例如：添加 token
        // const token = localStorage.getItem('token');
        // if (token) {
        //     config.headers.Authorization = `${token}`;
        // }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        // 直接返回响应数据，不判断业务状态码
        // 让业务代码在 .then() 中统一处理所有状态码
        return response.data;
    },
    (error) => {
        // 只处理真正的网络错误（超时、断网、HTTP错误等）
        if (error.response) {
            // HTTP 错误（4xx, 5xx）
            console.error('HTTP错误:', error.response.status);
        } else if (error.request) {
            // 请求已发出但没有收到响应（网络问题）
            console.error('网络错误:', error.message);
        } else {
            // 其他错误
            console.error('请求错误:', error.message);
        }
        return Promise.reject(error);
    }
);

// 封装 GET 请求
export function get<T>(url: string, params?: any, config?: AxiosRequestConfig): Promise<T> {
    return request.get(url, { params, ...config });
}

// 封装 POST 请求
export function post<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return request.post(url, data, config);
}

// 封装 PUT 请求
export function put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return request.put(url, data, config);
}

// 封装 DELETE 请求
export function del<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return request.delete(url, config);
}

export default request;
